<template>
  <div>
    <div class="flex-row justify-between align-center tab">
      <div class="flex-row">
        <toggle-button
          v-if="confirm"
          :value="enabled"
          :sync="true"
          @input="(value) => toggleSectionStatus('gallery', value)"
          color="#0074d9"
          :labels="true"
        />
        <toggle-button
          v-else
          :value="true"
          :sync="true"
          @input="(value) => toggleSectionStatus('gallery', value)"
          color="#0074d9"
          :labels="true"
        />
        <span class="text">Gallery</span>
      </div>
      <!-- <i class="fas fa-chevron-up icon-primary" v-if="enabled"></i>
      <i class="fas fa-chevron-down icon-primary" v-else></i>-->
    </div>
    <div class="container my-3" v-if="enabled">
      <h5 class="my-3">Title Section</h5>
      <div class="row" style="text-align: left">
        <div class="col-md-6">
          <b-form-group
            label-cols-sm="3"
            label-cols-md="3"
            label-cols-lg="3"
            label-cols-xl="2"
            label="Thai title"
            label-align-sm="left"
            label-for="nested-street"
          >
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="section.title.th"
              />
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            label-cols-sm="3"
            label-cols-md="3"
            label-cols-lg="3"
            label-cols-xl="2"
            label="Eng title"
            label-align-sm="left"
            label-for="nested-street"
          >
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="section.title.en"
              />
            </div>
          </b-form-group>
        </div>
      </div>
      <hr class="bold" />
      <GalleryCategoryTable
        :data.sync="gallerys"
        :onUpdateGallery="onUpdateGallery"
        :onAddGallery="onAddGallery"
        :projectID="projectID"
        :onDeleteGallery="onDeleteGallery"
        :onFetchGalleryList="onFetchGalleryList"
        :onSorting="onSorting"
      />
      <b-button-group>
        <b-btn
          size="sm"
          variant="primary"
          class="btn-group-space"
          @click="updateSection(section, true)"
          >Save</b-btn
        >
      </b-button-group>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { ActionFetch } from '@/store/actionTypes'
import GalleryCategoryTable from '@/components/tables/GalleryCategoryTable'
export default {
  props: {
    projectID: Number,
    section: Object,
    enabled: Boolean,
    confirm: Boolean,
    toggleSectionStatus: Function,
    updateSection: Function,
  },
  components: {
    GalleryCategoryTable,
  },
  data: () => ({
    gallerys: [],
  }),
  methods: {
    ...mapActions({
      getGalleryList: ActionFetch.PROJECTS.GALLERY.INDEX,
      onUpdateGallery: ActionFetch.PROJECTS.GALLERY.UPDATE,
      onDeleteGallery: ActionFetch.PROJECTS.GALLERY.DELETE,
      onAddGallery: ActionFetch.PROJECTS.GALLERY.ADD,
      onSorting: ActionFetch.PROJECTS.GALLERY.SORT,
    }),
    onFetchGalleryList() {
      this.gallerys = []
      this.getGalleryList(this.projectID).then((resp) => {
        if (this.$store.state.project && this.$store.state.project.gallerys) {
          this.gallerys = this.$store.state.project.gallerys
        }
      })
    },
    handleGalleryList() {
      if (this.$store.state.project && this.$store.state.project.gallerys) {
        this.gallerys = this.$store.state.project.gallerys
      } else {
        this.onFetchGalleryList()
      }
    },
  },
  created() {
    this.handleGalleryList()
  },
}
</script>

<style scoped></style>
